import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export type SubscriptionPlan =
  // Legacy
  | 'trial'
  | 'starter'
  | 'pro'
  | 'toll_free'
  // Nouvelle grille (mai 2026)
  | 'solo'
  | 'team'
  | 'business'
  | 'premium'
  | 'enterprise'

export type SubscriptionStatus =
  | 'incomplete'
  | 'incomplete_expired'
  | 'trialing'
  | 'active'
  | 'past_due'
  | 'canceled'
  | 'unpaid'
  | 'paused'

export interface Subscription {
  id: number
  plan: SubscriptionPlan
  plan_display: string
  status: SubscriptionStatus
  status_display: string
  current_period_start: string
  current_period_end: string
  trial_end: string | null
  cancel_at_period_end: boolean
  canceled_at: string | null
  is_active: boolean
  is_trial: boolean
  days_until_trial_end: number
  created_at: string
  updated_at: string
  /**
   * État de la bannière de recouvrement, calculé côté backend (honore aussi la
   * suspension manuelle admin) : 'none' | 'late' (paiement en retard) |
   * 'suspended' (sortant suspendu). L'entrant reste toujours actif.
   */
  outbound_banner?: 'none' | 'late' | 'suspended'
}

export interface SubscriptionStatusResponse {
  has_subscription: boolean
  subscription: Subscription | null
  /**
   * État de la bannière calculé sur l'abonnement du PROPRIÉTAIRE de la
   * company : présent même quand l'utilisateur (agent invité) n'a pas
   * d'abonnement à lui — sans quoi il serait bloqué (402) sans explication.
   */
  outbound_banner?: 'none' | 'late' | 'suspended'
}

/** GET /api/stripe/subscription-status/ — statut abonnement courant. */
export function useSubscriptionStatus() {
  return useQuery({
    queryKey: ['subscription-status'],
    queryFn: async () => {
      const { data } = await api.get<SubscriptionStatusResponse>(
        '/api/stripe/subscription-status/',
      )
      return data
    },
    staleTime: 60_000,
  })
}
